import React from 'react';
import { Field } from 'formik';
import WizardStep from './wizard_step';
import HomeIcon from './home.png';
import SolarIcon from './solar.png';
import Woodland from './legacy/woodland.png';
import GreenEnergy from './legacy/green-energy.png';
import Armadillo from './legacy/armadillo.png';
import Lightbulb from './legacy/lightbulb.png';
import BigHouse from './legacy/big-glamourous-house.png';
import LightBill from './legacy/idea.png';
import ElectricCar from './legacy/electric-car.png';

const LegacyWizardStep = () => (
  <WizardStep>
    <h2>
      Click below to build your energy profile. We'll send you a customized storage evaluation based
      on the info you provide.
    </h2>
    <div className="sgip-interests legacy">
      <div className="sgip-interest-item">
        <label htmlFor="existingSolar">
          <Field name="existingSolar" id="existingSolar" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={SolarIcon} alt="Solar panels" />
            </div>
            <div className="title">I have solar panels</div>
          </div>
        </label>
      </div>
      <div className="sgip-interest-item">
        <label htmlFor="goOffGrid">
          <Field name="goOffGrid" id="goOffGrid" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={Woodland} alt="Off grid" />
            </div>
            <div className="title">I want to go off grid</div>
          </div>
        </label>
      </div>
      <div className="sgip-interest-item">
        <label htmlFor="isHomeowner">
          <Field name="isHomeowner" id="isHomeowner" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={HomeIcon} alt="Homeowner" />
            </div>
            <div className="title">I own my home</div>
          </div>
        </label>
      </div>

      <div className="sgip-interest-item">
        <label htmlFor="valueCleanEnergy">
          <Field name="valueCleanEnergy" id="valueCleanEnergy" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={GreenEnergy} alt="Clean Energy" />
            </div>
            <div className="title">I value clean energy</div>
          </div>
        </label>
      </div>

      <div className="sgip-interest-item">
        <label htmlFor="energyProviders">
          <Field name="energyProviders" id="energyProviders" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={Armadillo} alt="Armadillo" />
            </div>
            <div className="title">I have a pet armadillo</div>
          </div>
        </label>
      </div>

      <div className="sgip-interest-item">
        <label htmlFor="preventOutage">
          <Field name="preventOutage" id="preventOutage" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={Lightbulb} alt="Power Outage" />
            </div>
            <div className="title">I don't want my power to go out</div>
          </div>
        </label>
      </div>

      <div className="sgip-interest-item">
        <label htmlFor="multiBedrooms">
          <Field name="multiBedrooms" id="multiBedrooms" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={BigHouse} alt="Large House" />
            </div>
            <div className="title">I have more than 3 bedrooms</div>
          </div>
        </label>
      </div>

      <div className="sgip-interest-item">
        <label htmlFor="highBill">
          <Field name="highBill" id="highBill" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={LightBill} alt="Utility bill" />
            </div>
            <div className="title">I have a high electric bill</div>
          </div>
        </label>
      </div>

      <div className="sgip-interest-item">
        <label htmlFor="driveEV">
          <Field name="driveEV" id="driveEV" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={ElectricCar} alt="Electric vehicle" />
            </div>
            <div className="title">I drive an electric car</div>
          </div>
        </label>
      </div>
    </div>
  </WizardStep>
);

export default LegacyWizardStep;
